import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const TempleOfArtemis = {
  id: '26',
  name: 'Temple of Artemis',
  era: EraType.bronzeAge,
  icon: 'toa',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.ANCIENT_WORLD,
  kind: WonderKind.TEMPLE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        5,
        6.4,
        7.5,
        8.4,
        9.1,  // 5
        9.8,
        10.4,
        10.9,
        11.4,
        11.9, // 10
        12.3,
        12.8,
        13.2,
        13.5,
        13.9, // 15
        14.3,
        14.6,
        14.9,
        15.3,
        15.6, // 20
        15.9,
        16.2,
        16.5,
        16.7,
        17,   // 25
        17.3,
        17.5,
        17.8,
        18,
        18.3  // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asCallbackWithLevel(
        function (level) {
          if (level === 30) {
            return 4;
          }
          if (level >= 15) {
            return 3;
          }
          return 2;
        }
      )
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(4).withKind(WonderKind.STATUE),
      effect: null,
    }
  ],
};

export default TempleOfArtemis;
